// import { React } from "react";
import { ListItem, Text, UnorderedList, Box } from "@chakra-ui/react";

const FirstArticle = () => {
  return (
    <Box
      fontFamily="inherit"
      fontSize={{ base: "14.5px", sm: "14px", md: "15px", lg: "17px" }}
    >
      <Text
        fontSize={{base: "calc(1em + 1px)", md: "calc(1em + 2px)", xl : "calc(1em + 3px)" }}
        m={{ base: "20px 0px 16px", sm: "28px 0px 20px", lg: "36px 0px 40px" }}
      >
        Psihoterapia de grup poate oferi o serie de beneficii semnificative
        atunci când este folosită pentru tratarea traumei. Traumele pot afecta
        profund individul și pot influența relațiile, comportamentele și starea
        emoțională. În cadrul unui grup terapeutic, persoanele care au
        experimentat traume similare sau diferite pot beneficia de următoarele
        aspecte:
      </Text>
      <UnorderedList>
        <ListItem my={{ base: "6px", md: "8px", lg: "16px" }}>
          <strong>Suport social și empatie: </strong>Grupurile terapeutice oferă
          un mediu sigur și acceptant în care membrii pot împărtăși experiențele
          lor și pot primi sprijin din partea celorlalți. Empatia și înțelegerea
          celor care au trecut prin traume similare pot ajuta la reducerea
          sentimentului de izolare și singurătate.
        </ListItem>
        <ListItem my={{ base: "6px", md: "8px", lg: "16px" }}>
          <strong>Normalizarea și validarea: </strong> Prin auzirea
          experiențelor altor persoane care au trecut prin traume, membrii
          grupului pot simți că nu sunt singuri și că ceea ce au trăit este
          validat. Normalizarea poate reduce sentimentul de vinovăție sau de
          rușine asociat traumei. Învățare și schimb de resurse: În cadrul
          grupurilor terapeutice, membrii pot împărtăși strategii eficiente
          pentru a gestiona consecințele traumei și pentru a face față
          dificultăților. Acest schimb de resurse poate fi inspirațional și
          motivant pentru fiecare participant.
        </ListItem>
        <ListItem my={{ base: "6px", md: "8px", lg: "16px" }}>
          <strong>Căutarea de sens: </strong>Discuțiile în grup pot ajuta la
          explorarea și înțelegerea mai profundă a impactului traumei și la
          găsirea de sens într-un mod colectiv. Acest proces poate contribui la
          reconstruirea identității și la gestionarea simptomelor de stres
          post-traumatic.
        </ListItem>
        <ListItem my={{ base: "6px", md: "8px", lg: "16px" }}>
          <strong>Confruntarea graduală: </strong>
          Participarea la grupuri terapeutice poate oferi o modalitate sigură de
          a explora și confrunta amintirile traumatice într-un mod treptat și
          controlat. Membrii pot găsi sprijin în gestionarea emoțiilor dificile
          care pot apărea în timpul acestui proces.
        </ListItem>
        <ListItem my={{ base: "6px", md: "8px", lg: "16px" }}>
          <strong>Dezvoltarea abilităților sociale: </strong>
          Interacțiunea cu alți membri ai grupului poate contribui la
          dezvoltarea și îmbunătățirea abilităților sociale. În cadrul grupului,
          membrii pot experimenta și practica modalități sănătoase de comunicare
          și relaționare.
        </ListItem>
        <ListItem my={{ base: "6px", md: "8px", lg: "16px" }}>
          <strong>Siguranță și încredere: </strong>
          Construirea unui mediu sigur și încrezător în cadrul grupului este
          crucială. Atunci când se simt în siguranță, membrii pot fi mai dispuși
          să împărtășească experiențe personale și să exploreze aspecte
          sensibile legate de traumă.
        </ListItem>
        <ListItem my={{ base: "6px", md: "8px", lg: "16px" }}>
          <strong>Promovarea rezilienței: </strong>Grupurile terapeutice pot
          contribui la dezvoltarea abilităților de față și la promovarea
          resilienei în fața traumei. Membrii pot învăța strategii pentru a face
          față și a depăși provocările, construind o bază solidă pentru
          recuperare. Este important să menționăm că nu toată lumea se simte
          confortabil sau beneficiază de terapia de grup, iar preferințele
          individuale pot varia. Psihoterapia de grup ar trebui să fie
          facilitată de un terapeut calificat și să se desfășoare într-un cadru
          etic și profesional.
        </ListItem>
      </UnorderedList>
    </Box>
  );
};

export default FirstArticle;
